/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import PropTypes from "prop-types";
import NextLink from "next/link";

import api from "../api";

const client = api();
export default function Link({ children, events, className, ...rest }) {
  const onRouteChange = () => {
    events.forEach((event) => {
      client.trackAnalyticsEvents(event).catch(() => {});
    });
  };

  return (
    <NextLink {...rest}>
      <a className={className} onClick={onRouteChange}>
        {children}
      </a>
    </NextLink>
  );
}

Link.propTypes = {
  href: PropTypes.string.isRequired,
  as: PropTypes.string,
  passHref: PropTypes.bool,
  replace: PropTypes.bool,
  scroll: PropTypes.bool,
  shallow: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  events: PropTypes.arrayOf(
    PropTypes.shape({
      event: PropTypes.string.isRequired,
      properties: PropTypes.shape({}).isRequired,
    }),
  ),
};

Link.defaultProps = {
  as: undefined,
  passHref: false,
  replace: false,
  scroll: true,
  shallow: false,
  events: [],
  className: undefined,
};
